export const CATALOG_PRODUCTS_URL = `catalog/products`;
export const CATALOG_PRODUCTS_RETURNABLE_ACCESSORIES_URL = `${CATALOG_PRODUCTS_URL}/returnable-accessories`;
